var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGameIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 79.1 122.5",
    style: {
      enableBackground: "new 0 0 79.1 122.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:5;stroke-linejoin:round;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Layer 26 (2)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.3,61.1V46.2l0,0c-10.6-8-26.7-24.9-28.4-27c0,0-0.1-3.1-0.1-4.8C1.8,3,18,2.4,19.8,2.3 C38.6,0.5,59.9,3.5,77.3,11l0,0v100.5l0,0c-17.4,7.5-38.7,10.5-57.5,8.8c-1.7-0.2-18-0.7-18-12.1c0-1.8,0.1-4.8,0.1-4.8 c1.7-2.1,17.8-19.1,28.4-27l0,0V61.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.3,28.3L62.7,44.7c-1.1,1-1.6,2.3-1.7,3.7v25.6c0,1.4,0.6,2.8,1.7,3.8l14.5,16.1"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 42.8,
    cy: 82,
    r: 6.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 42.8,
    cy: 40.5,
    r: 6.1
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "1.8,103.4 5.4,90.7 18.7,72.9 18.7,50.1 5.4,30.3 1.8,19.2  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 58.2,
    y1: 13.1,
    x2: 58.2,
    y2: 31.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 49.1,
    y1: 22.1,
    x2: 67.3,
    y2: 22.1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 64.8,
    cy: 99.8,
    r: 3.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 58.2,
    cy: 106.3,
    r: 3.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 58.2,
    cy: 93.2,
    r: 3.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 51.6,
    cy: 99.8,
    r: 3.3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameIcon);
export default __webpack_public_path__ + "static/media/Game--icon.45836df979e9a00a9dd53cc4f924db89.svg";
export { ForwardRef as ReactComponent };